import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, ProtectedRoute, configureAuth } from '@webmotors/consumer-shared-auth';
import { AuthLoadingFallback } from '@/components/auth-loading-fallback';
import { ENV } from '@/app/config';
import { useApp } from '@/app/app.hook';
import { ABRouter } from '@/app/router';
import { initDatadog } from '@/services/observability';
import { ABTestProvider } from '@/hooks/ab-test';
import { ToastProvider } from '@/components/toast';

configureAuth({
	env: ENV.AUTH_ENV,
	...(ENV.URL_LOGIN ? { loginUrl: ENV.URL_LOGIN } : {})
});

initDatadog();

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			staleTime: 1000 * 60 * 5,
			retry: 2,
			refetchOnWindowFocus: false
		}
	}
});

const App = () => {
	const { isReady } = useApp();

	if (!isReady) {
		return null;
	}

	return (
		<QueryClientProvider client={queryClient}>
			<AuthProvider>
				<ProtectedRoute fallback={<AuthLoadingFallback />}>
					<ToastProvider>
						<ABTestProvider>
							<ABRouter />
						</ABTestProvider>
					</ToastProvider>
				</ProtectedRoute>
			</AuthProvider>
		</QueryClientProvider>
	);
};

App.displayName = 'App';

export { App };
